import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostBinding,
  Input,
  OnInit
} from '@angular/core';
import { AppConstants } from '@utils/app.constants';

@Directive({
  selector: 'label[lm-label]', // tslint:disable-line
  exportAs: 'lm-label'
})
export class LMLabelDirective implements OnInit, AfterViewInit {
  @Input() layoutField: LMFormLayoutField;
  @Input() layoutInfo: LMFormLayoutInfo;
  @Input() lmColumnLayoutInfo: LMColumnLayoutInfo;
  @Input() lmParagraphLayoutInfo: LMParagraphLayoutInfo;
  @Input() parentIsFormLayout: boolean;
  @Input() id: string;
  @Input() displayInlineBlock: false;
  @Input() checkBoxIsDisplayAsText: false;
  @Input() personalize: false;
  @Input() isCompoundFieldMember: false;

  private label: LMLabelLayout;

  constructor(private elementRef: ElementRef) {
  }

  /**
   * used to set the foreground color when an upper element has
   * a class of `personalize-header` that has a parent element
   * with a class of `is-personalizable`
   */
  @HostBinding('class.personalize-text') get shouldPersonalize() {
    return this.personalize;
  }

  @HostBinding('class.lm-number-label') get isNumberLabel() {
    return this.layoutField && this.layoutField.numberLabel;
  }

  @HostBinding('class.lm-no-label') get isNoLabel(): boolean {
    // No label if form text in a single column
    if (this.layoutField?.type?.toUpperCase() === AppConstants.FORMTEXT && this.lmColumnLayoutInfo?.nbrColumns === 1) {
      return true;
    }

    if (this.layoutField?.labelSuppressed) {
      return true;
    }

    if (this.layoutField?.mouseOverText) {
      return false;
    }

    return this.label && this.label.nolabel;
  }

  @HostBinding('class.lm-paragraph-no-label') get hasNoVisibleLabels(): boolean {
    return this.lmParagraphLayoutInfo && !this.lmParagraphLayoutInfo.hasVisibleLabels;
  }

  @HostBinding('class.no-colon') get isNoColon(): boolean {
    // Exclude paragraph layouts
    if (this.lmParagraphLayoutInfo && !this.isCompoundFieldMember) {
      return false;
    }

    // No label if form text in a single column
    if ((this.layoutField && this.layoutField.type && this.layoutField.type.toUpperCase()) === AppConstants.FORMTEXT
      && (this.lmColumnLayoutInfo && this.lmColumnLayoutInfo.nbrColumns === 1)
    ) {
      return true;
    }

    return this.label && this.label.noColon;
  }

  ngOnInit() {
    if (this.layoutField) {
      this.label = <LMLabelLayout>this.layoutField.label;
    }
  }

  ngAfterViewInit() {
    if (this.lmColumnLayoutInfo) {
      if (this.lmColumnLayoutInfo && this.elementRef && (this.lmColumnLayoutInfo.imageInFirstColumn || this.lmColumnLayoutInfo.distributed)) {
        this.elementRef.nativeElement.setAttribute('title', this.elementRef.nativeElement.textContent);
      }
    }
  }
}
